import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DatePicker from "react-bootstrap-date-picker";
class InputCustom extends Component {
  render() {
    if (this.props.type === "date") {
      var dayLabels = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
      var monthLabels = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      return (
        <div className={this.props.sizeClass}>
          <div className="form-group label-floating">
            <label className="control-label">{this.props.label}</label>
            <DatePicker
              placeholder={this.props.placeholder || undefined}
              monthLabels={monthLabels}
              dayLabels={dayLabels}
              onChange={this.props.onChange}
              value={this.props.value}
              className="form-control"
              disabled={this.props.disabled}
              showClearButton={false}
            />
            <span className="label label-danger">{this.props.error}</span>
          </div>
        </div>
      );
    } else if (this.props.type === "radio") {
      return (
        <div className={this.props.sizeClass} style={{ marginTop: 20 }}>
          <div className="form-check form-check-radio">
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="radio"
                style={{ marginRight: 10 }}
                name={this.props.name}
                id={this.props.id}
                onChange={this.props.onChange}
                value={this.props.value}
                checked={this.props.checked}
              />
              {this.props.label}
              <span className="circle">
                <span className="check" />
              </span>
            </label>
          </div>
        </div>
      );
    } else {
      return (
        <div className={this.props.sizeClass}>
          <div className="form-group label-floating">
            <label className="control-label">{this.props.label}</label>
            <input
              min={this.props.min}
              max={this.props.max}
              step={this.props.step}
              onChange={this.props.onChange}
              checked={this.props.checked}
              value={this.props.value}
              onBlur={this.props.onBlur}
              type={this.props.type}
              className="form-control"
              disabled={this.props.disabled}
            />
            <span className="label label-danger">{this.props.error}</span>
          </div>
        </div>
      );
    }
  }
}
export default withRouter(InputCustom);



// WEBPACK FOOTER //
// ./src/components/InputCustom.js